import React from "react";
import { Box, Card, CardContent, Skeleton, Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { cardStyles } from "../styles/clientePortalStyles";

// ==================== ESTILOS ====================

const useStyles = makeStyles((theme) => ({
  card: {
    ...cardStyles,
    height: "100%",
  },
}));

/**
 * Componente CardSkeleton - Loading state para cards
 *
 * @param {number} count - Cantidad de cards a mostrar (default: 3)
 * @param {number} xs - Tamaño en xs (default: 12)
 * @param {number} sm - Tamaño en sm (default: 6)
 * @param {number} md - Tamaño en md (default: 4)
 * @param {number} height - Altura del card en px (default: 200)
 *
 * @example
 * {isLoading && <CardSkeleton count={3} />}
 *
 * @example con tamaños personalizados
 * {isLoading && (
 *   <CardSkeleton
 *     count={2}
 *     xs={12}
 *     md={6}
 *     height={250}
 *   />
 * )}
 */
export default function CardSkeleton({
  count = 3,
  xs = 12,
  sm = 6,
  md = 4,
  height = 200,
}) {
  const classes = useStyles();

  return (
    <Grid container spacing={3}>
      {[...Array(count)].map((_, index) => (
        <Grid item xs={xs} sm={sm} md={md} key={index}>
          <Card className={classes.card}>
            <CardContent>
              {/* Título */}
              <Skeleton
                variant="text"
                width="60%"
                height={32}
                animation="wave"
                style={{ marginBottom: 16 }}
              />

              {/* Subtítulo */}
              <Skeleton
                variant="text"
                width="40%"
                height={20}
                animation="wave"
                style={{ marginBottom: 24 }}
              />

              {/* Contenido */}
              <Skeleton
                variant="rectangular"
                width="100%"
                height={height - 140}
                animation="wave"
                style={{ borderRadius: 8 }}
              />

              {/* Footer */}
              <Box sx={{ mt: 2, display: "flex", gap: 1 }}>
                <Skeleton
                  variant="rectangular"
                  width={80}
                  height={32}
                  animation="wave"
                  style={{ borderRadius: 6 }}
                />
                <Skeleton
                  variant="rectangular"
                  width={80}
                  height={32}
                  animation="wave"
                  style={{ borderRadius: 6 }}
                />
              </Box>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
}
